import { SideNav, SideNavContent } from "components";
import { BackButton, HomeWrapper } from "components/CdBalance/style";
import { BaseInput, HeaderDasNew, LargeButton, Ptag } from "components/core";
import React from "react";
import backarrow from "../../../assets/images/arrowBack.png";
import styled from "styled-components";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import http from "services/httpService";
import {
  formatAmount,
  formatDate,
  formatToRupees,
  healthIssuancePresent,
  rupeesToNumber,
} from "utlis/utils";
import { useNavigate } from "react-router";
import routes from "components/routes";
import { ButtonWrapper } from "pages/UploadPolicyDocument/styles";

function UpdateCorporateBuffer() {
  const company_name = localStorage.getItem("company_name");
  const navigate = useNavigate();
  const navigateToCb = () => {
    navigate(`/${routes.VIEW_CORPORATE_BUFFER}`);
  };
  const updateData = async (value) => {
    try {
      const payload = value;
      payload.date_of_admission = formatDate(payload.date_of_admission);
      payload.buffer_amount_utilised = rupeesToNumber(
        payload.buffer_amount_utilised
      );
      const userplanId = healthIssuancePresent();
      payload.userplan_id = userplanId;
      const { data } = await http.post(
        "/business/submit_claims_cb_data/",
        payload
      );
      navigate(`/${routes.VIEW_CORPORATE_BUFFER}`);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <SideNav>
        <SideNavContent />
      </SideNav>
      <HeaderDasNew company_name={company_name} />
      <HomeWrapper>
        <LocalHeader onClick={() => navigateToCb()}>
          <img
            style={{ marginRight: "10px" }}
            src={backarrow}
            height="24px"
            width="24px"
          />
          <Ptag
            fontSize="20px"
            fontWeight="500"
            letterHeight="1.33"
            letterSpacing="0.35px"
          >
            Update Corporate Buffer Utilisation
          </Ptag>
        </LocalHeader>
        <Formik
          validationSchema={schema}
          initialValues={initialValue}
          onSubmit={updateData}
        >
          {(formikProps) => (
            <div style={{ marginBottom: "2.8rem", maxWidth: "800px" }}>
              <Form
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "3rem",
                  marginTop: "3rem",
                  marginLeft: "1rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "4rem",
                    width: "100%",
                  }}
                  className="date-numeber-wrapper"
                >
                  <BaseInput
                    staticLabel="Claim No."
                    phone
                    fontSize="14px !important"
                    formikProps={{
                      ...formikProps,
                      name: "claim_number",
                    }}
                  />
                  <BaseInput
                    staticLabel="Employee Number"
                    fontSize="14px !important"
                    formikProps={{
                      ...formikProps,
                      name: "employee_number",
                    }}
                  />
                </div>
                <BaseInput
                  staticLabel="Employee Name"
                  fontSize="14px !important"
                  formikProps={{
                    ...formikProps,
                    name: "patient_name",
                  }}
                />
                <BaseInput
                  staticLabel="Patient Name"
                  fontSize="14px !important"
                  formikProps={{
                    ...formikProps,
                    name: "employee_name",
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    gap: "4rem",
                    width: "100%",
                  }}
                  className="date-numeber-wrapper"
                >
                  <BaseInput
                    staticLabel="Date of Admission"
                    date
                    fontSize="14px !important"
                    formikProps={{
                      ...formikProps,
                      name: "date_of_admission",
                    }}
                  />
                  <BaseInput
                    staticLabel="Buffer Amount Utilised"
                    formatToRupee
                    fontSize="14px !important"
                    formikProps={{
                      ...formikProps,
                      name: "buffer_amount_utilised",
                    }}
                  />
                </div>
                <ButtonWrapper style={{ padding: 0 }}>
                  <LargeButton
                    // marginTop="24px"
                    id="business_about_next12"
                    textTransform="none"
                    label={"Update"}
                    type="submit"
                  />
                </ButtonWrapper>
              </Form>
            </div>
          )}
        </Formik>
      </HomeWrapper>
    </>
  );
}

export default UpdateCorporateBuffer;

const initialValue = {
  claim_number: "",
  employee_number: "",
  employee_name: "",
  patient_name: "",
  date_of_admission: "",
  buffer_amount_utilised: "",
};

const schema = Yup.object().shape({
  claim_number: Yup.number().required("Claim number is required"),
  employee_number: Yup.string().required("Employee number is required"),
  employee_name: Yup.string().required("Employee name is required"),
  patient_name: Yup.string().required("Patient name is required"),
  date_of_admission: Yup.string().required("Date of admission is required"),
  buffer_amount_utilised: Yup.string().required(
    "Buffer amount utilized is required"
  ),
});

export const LocalHeader = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
